import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { FirebaseProvider } from './contexts/FirebaseContext';
import { AuthProvider } from './contexts/AuthContext';
import { ViewModeProvider } from './contexts/ViewModeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import AuthActionPage from './pages/AuthActionPage';
import HomePage from './pages/HomePage';
import HomesPage from './pages/HomesPage';
import HomeDetailPage from './pages/HomeDetailPage';
import BookingsPage from './pages/BookingsPage';
import BragBoardPage from './pages/BragBoardPage';
import AdminPage from './pages/AdminPage';
import EditPropertyPage from './pages/EditPropertyPage';
import AddPropertyPage from './pages/AddPropertyPage';
import ProfilePage from './pages/ProfilePage';
import InvitePage from './pages/InvitePage';
import './App.css';

const AnalyticsPage = lazy(() => import('./pages/AnalyticsPage'));

function App() {
  return (
    <FirebaseProvider>
      <AuthProvider>
        <LanguageProvider>
          <ViewModeProvider>
            <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/action" element={<AuthActionPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout>
                    <HomePage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/homes"
              element={
                <ProtectedRoute>
                  <Layout>
                    <HomesPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/homes/:id"
              element={
                <ProtectedRoute>
                  <Layout>
                    <HomeDetailPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/bookings"
              element={
                <ProtectedRoute>
                  <Layout>
                    <BookingsPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/brag-board"
              element={
                <ProtectedRoute>
                  <Layout>
                    <BragBoardPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Suspense fallback={
                      <div className="flex items-center justify-center min-h-[60vh]">
                        <div className="w-10 h-10 border-4 border-border border-t-primary rounded-full animate-spin" />
                      </div>
                    }>
                      <AnalyticsPage />
                    </Suspense>
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Layout>
                    <AdminPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/properties/new"
              element={
                <ProtectedRoute>
                  <Layout>
                    <AddPropertyPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/properties/:id/edit"
              element={
                <ProtectedRoute>
                  <Layout>
                    <EditPropertyPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ProfilePage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route path="/invite/:token" element={<InvitePage />} />
          </Routes>
            </Router>
          </ViewModeProvider>
        </LanguageProvider>
      </AuthProvider>
    </FirebaseProvider>
  );
}

export default App;
